import { Translation } from '../contexts/TranslationContext'

export const recommendedActivity = (metabolizedEnergy: number | undefined) => {
	if (metabolizedEnergy && metabolizedEnergy > 0) {
		if (metabolizedEnergy < 4000) {
			return <Translation tr="recommendedActivity.low" />
		}
		if (metabolizedEnergy > 4000 || metabolizedEnergy <= 4499) {
			return <Translation tr="recommendedActivity.mid" />
		}
		if (metabolizedEnergy >= 4500) {
			return <Translation tr="recommendedActivity.high" />
		}
	}

	return <Translation tr="recommendedActivity.notSpecified" />
}
